import React, { useState, useEffect, useRef } from 'react';

import { formatNumber, getInputValue, formatNumericValue, parseInputValue, renderSyncIcon } from '../utils';

const CommercialSection = ({ value = 0, totalCost = 0, onChange, isEditable = true, onRecost }) => {
	const [commercial, setCommercial] = useState(value);
	const [hasChanged, setHasChanged] = useState(false);
	const isInitialMount = useRef(true);
	const prevValueRef = useRef(null);

	useEffect(() => {
		if (prevValueRef.current === value) {
			return;
		}

		if (value !== '' && value !== null && value !== undefined) {
			setCommercial(formatNumericValue(value));
		} else {
			setCommercial(value);
		}

		prevValueRef.current = value;
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}
	}, [value]);

	const notifyChange = (updatedCommercial) => {
		if (onChange && !isInitialMount.current) {
			onChange(formatNumericValue(updatedCommercial));
		}
	};

	const handleInputChange = (e) => {
		const value = e.target.value;
		const updatedCommercial = parseInputValue(value);
		setCommercial(updatedCommercial);
		setHasChanged(true);
		notifyChange(updatedCommercial);
	};

	const displayCost = totalCost || 0;

	const onRecostChange = () => {
		onRecost('COMMERCIAL_CHANGE');
		setHasChanged(false);
	};

	return (
		<div className="single-table trims-content border mt-5">
			<div className="table-heading d-flex align-items-center justify-content-between">
				<p>
					Commercial Cost Metrics
					{hasChanged && (
						<span
							title="Unsaved changes"
							className="sync-icon ml-1 cursor-pointer"
							style={{ display: 'inline-flex', alignItems: 'center' }}
							onClick={onRecostChange}
						>
							{renderSyncIcon()}
						</span>
					)}
				</p>
			</div>
			<div className="row align-items-center py-2 border-bottom border-top m-0">
				<div className="col-md-2 pr-0">
					<p className="regular-12 gray_dark_02 pb-1">Commercial Charge (%)</p>
				</div>
				<div className="col-md-10">
					<input
						type="number"
						step="0.01"
						value={getInputValue(commercial)}
						onChange={handleInputChange}
						readOnly={!isEditable}
					/>
				</div>
			</div>
			<div className="row align-items-center m-0 total-row">
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01">Total Commercial Cost</p>
				</div>
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01 float-right">${formatNumber(displayCost)}</p>
				</div>
			</div>
		</div>
	);
};

export default CommercialSection;
